export default __webpack_public_path__ + "static/media/JPMorgan.9487fb5e.jpeg";